export default "__VITE_ASSET__Dn3rqfOA__"